"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TabContext;
exports.getPanelId = getPanelId;
exports.getTabId = getTabId;
exports.useTabContext = useTabContext;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
/**
 * @type {React.Context<{ idPrefix: string; value: string } | null>}
 */ var Context = /*#__PURE__*/ React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
    Context.displayName = 'TabContext';
}
function useUniquePrefix() {
    var _React_useState = _sliced_to_array(React.useState(null), 2), id = _React_useState[0], setId = _React_useState[1];
    React.useEffect(function() {
        setId("mui-p-".concat(Math.round(Math.random() * 1e5)));
    }, []);
    return id;
}
function TabContext(props) {
    var children = props.children, value = props.value;
    var idPrefix = useUniquePrefix();
    var context = React.useMemo(function() {
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Context.Provider, {
        value: context,
        children: children
    });
}
process.env.NODE_ENV !== "production" ? TabContext.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * The value of the currently selected `Tab`.
   */ value: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.string
    ]).isRequired
} : void 0;
/**
 * @returns {unknown}
 */ function useTabContext() {
    return React.useContext(Context);
}
function getPanelId(context, value) {
    var idPrefix = context.idPrefix;
    if (idPrefix === null) {
        return null;
    }
    return "".concat(context.idPrefix, "-P-").concat(value);
}
function getTabId(context, value) {
    var idPrefix = context.idPrefix;
    if (idPrefix === null) {
        return null;
    }
    return "".concat(context.idPrefix, "-T-").concat(value);
}
